module.exports = __webpack_public_path__ + "static/media/step_013.37c23919.jpeg";